export const CookieConsentStyling = {
	"sx": {
		"&[src]": {
			display: "none"
		}
	}
}